import { ValidationError } from '@cian/peperrors/shared';
import { setScheduleData } from '../../../shared/actions/flatTourBooking';
import { transformFlatTourBookingSchedule } from '../../../shared/mappers/transformFlatTourBookingSchedule';
import {
  fetchGetFlatTourBookingSchedule,
  TGetFlatTourBookingScheduleResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/get-flat-tour-booking-schedule';
import { getIsFlatViewOrderEnabled } from '../../../shared/selectors/flatViewOrder';
import { getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { isValidFlatTourBookingSchedule } from '../../../shared/utils/flatTourBooking';

export function getFlatTourBookingSchedule(): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    try {
      const state = getState();
      const isTourEnabled = getIsFlatViewOrderEnabled(state);

      if (!isTourEnabled) {
        return;
      }

      const newbuildingId = getNewbuildingId(state);

      const response: TGetFlatTourBookingScheduleResponse = await fetchGetFlatTourBookingSchedule({
        httpApi,
        parameters: { newbuildingId },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      const flatToutBookingSchedule = response.response.schedule;

      if (!isValidFlatTourBookingSchedule(flatToutBookingSchedule)) {
        const error = new ValidationError({
          message: 'Ошибка валидации в isValidFlatTourBookingSchedule',
          domain: 'shared/utils/flatTourBooking/isValidFlatTourBookingSchedule.ts#isValidFlatTourBookingSchedule',
        });

        throw error;
      }

      const transformedScheduleData = transformFlatTourBookingSchedule(flatToutBookingSchedule);
      dispatch(setScheduleData(transformedScheduleData));
    } catch (error) {
      logger.error(error, {
        domain: 'getFlatTourSchedule',
      });
    }
  };
}
